import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material'; // Import GlobalStyles
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Navbar from './components/Navbar';
import GoogleAnalytics from './components/GoogleAnalytics';
import GoogleReviews from './components/GoogleReviews';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
// import PromotionFooter from './components/PromotionFooter';
// import Promotions from './pages/Promotions';
import WhyUs from './pages/WhyUs';
import DoctorProfile from './pages/DoctorProfile';
import DentalExamsCleanings from './pages/services/general-dentistry/DentalExamsCleanings';
import Fillings from './pages/services/general-dentistry/Fillings';
import RootCanals from './pages/services/general-dentistry/RootCanals';
import TeethWhitening from './pages/services/cosmetic-dentistry/TeethWhitening';
import Veneers from './pages/services/cosmetic-dentistry/Veneers';
import DentalBridges from './pages/services/general-dentistry/DentalBridges';
import DentalCrowns from './pages/services/general-dentistry/DentalCrown';
import Extraction from './pages/services/general-dentistry/Extraction';
import NightGuards from './pages/services/general-dentistry/NightGuard';
import DentalBonding from './pages/services/cosmetic-dentistry/DentalBonding';
import Invisalign from './pages/services/cosmetic-dentistry/Invisalign';
import EmergencyChippedTooth from './pages/services/emergency/ChippedTooth';
import Sealants from './pages/services/pediatric-dentistry/Sealant';
import Implant from './pages/services/implant/Implants';

const theme = createTheme({
  palette: {
    primary: {
      main: '#77A4DD',
    },
    secondary: {
      main: '#77A4DD',
    },
    background: {
      default: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: '#A0A0A0',
      disabled: '#9e9e9e',
    },
  },
  shape: {
    borderRadius: 5,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <GoogleAnalytics />
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          // REMOVED overflowX: 'hidden' from here
          // This Box should allow its content to overflow vertically,
          // and the browser will handle page scroll for body/html.
        }}>
          <Navbar />
          {/* The Routes component will render the page content.
              If this content is taller than the viewport, vertical scroll should appear.
              You could wrap Routes in another Box with flexGrow: 1 if you wanted
              more specific control over the content area vs. the Navbar,
              but for page-level scroll, this setup is fine.
          */}
          <Box component="main" sx={{ flexGrow: 1 }}> {/* Ensures content area can grow */}
            <Routes>
              <Route path="/" element={
                <>
                  <Home />
                  <About />
                  <Services />
                  <WhyUs />
                  <GoogleReviews />
                  <Contact />
                  {/* <Promotions /> */}
                </>
              } />
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/contact" element={<Navigate to="/#contact" replace />} />
              <Route path="/about" element={<Navigate to="/#about" replace />} />
              <Route path="/services" element={<Navigate to="/#services" replace />} />
              <Route path="/why-us" element={<Navigate to="/#why-us" replace />} />
              <Route path="/members/:doctorId" element={<DoctorProfile />} />
              <Route path="/services/general-dentistry/dental-exams--cleanings" element={<DentalExamsCleanings />} />
              <Route path="/services/general-dentistry/fillings" element={<Fillings />} />
              <Route path="/services/general-dentistry/dental-crowns" element={<DentalCrowns />} />
              <Route path="/services/general-dentistry/dental-bridges" element={<DentalBridges />} />
              <Route path="/services/general-dentistry/extractions" element={<Extraction />} />
              <Route path="/services/general-dentistry/night-guards" element={<NightGuards />} />
              <Route path="/services/cosmetic-dentistry/teeth-whitening" element={<TeethWhitening />} />
              <Route path="/services/cosmetic-dentistry/porcelain-veneers" element={<Veneers />} />
              <Route path="/services/cosmetic-dentistry/dental-bonding" element={<DentalBonding />} />
              <Route path="/services/cosmetic-dentistry/invisalign-clear-aligners" element={<Invisalign />} />
              <Route path="/services/emergency-care/urgent-extractions" element={<Extraction />} />
              <Route path="/services/emergency-care/emergency-root-canal" element={<RootCanals />} />
              <Route path="/services/emergency-care/chipped-tooth-repair" element={<EmergencyChippedTooth />} />
              <Route path="/services/pediatric-dentistry/sealants" element={<Sealants />} />
              <Route path="/services/dental-implants/dental-implants" element={<Implant />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;